import { useTranslation } from 'react-i18next';

import { MessageV2DTO } from 'support/types';
import { Severity } from 'support/types/ui';
import { AlertSection } from 'components/Display/Alert';
import { Alert } from 'components/Display/Alert/Alert';
import { Translate } from 'components/Translate/Translate';

type Props = {
  blockingError: NonNullable<MessageV2DTO['blocking_error']>;
  severity: Severity;
};

export const GenericBlockingPreset = ({ blockingError, severity }: Props) => {
  const { t } = useTranslation();

  return (
    <Alert withoutIcon severity={severity} fullWidth className="max-h-72 overflow-y-auto">
      <AlertSection severity={severity} title={blockingError.title}>
        {blockingError.description ? <Translate i18nKey={blockingError.description} /> : null}
      </AlertSection>
      {blockingError.howToFix ? (
        <AlertSection severity={severity} title={t('common:blockingError.howToFix')}>
          <Translate i18nKey={blockingError.howToFix} />
        </AlertSection>
      ) : null}
    </Alert>
  );
};
